module.exports = __webpack_public_path__ + "img/preview3.3e65a29f.webp";